<template>
    <v-card>
        <div class="div">
            <img :src="require('@/assets/logosurdarkblue.png')" class="logo-login">
        </div>
        <v-text-field label="email" v-model="sesion.email"></v-text-field>
        <v-text-field label="password" type="password" v-model="sesion.password"></v-text-field>
        <v-btn @click="login">Iniciar Sesi&oacute;n</v-btn>
    </v-card>
    <v-snackbar :timeout="1500" color="red-darken-4" v-model="alertState"> {{ alertMsg }}</v-snackbar>
</template>
<script>
import axios from 'axios';
export default{
    data(){
        return{
            sesion:{
                'email':'',
                'password':''
            },
            alertState:false,
            alertMsg:''
        }
    },
    methods:{
        login(){
            axios.post(`${this.$store.state.dominio}/login`,this.sesion)
            .then(
                response=>{
                    if(response.status ==200){
                        let datos = {
                            'user':response.data.data.name,
                            'token':response.data.token,
                            'rol':response.data.data.fk_rol
                        }

                        this.$store.dispatch('login',datos);
                        this.$router.push('/carnet')
                    }
                }
            )
            .catch(
                error=>{
                    console.log("Aocurrido un error "+error);
                    //salte la alerta
                    this.alertState = true;
                    //muestra el mensaje en la alerta
                    if(error.response.status==401){
                        this.alertMsg = error.response.data.data
                    }else{
                        this.alertMsg = 'Algo salio mal!'
                    }
                }
            )
        }
    }
}
</script>
<style scoped>
.v-card{
    margin: 200px auto;
    width: 50%;
    padding: 20px;
}

.div{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.logo-login{
    width: 400px;
    height: 150px;
    object-fit: cover;
}
</style>